(function () {
    'use strict';

    angular
        .module('memories')
        .directive('xxMemoryEdit', xxMemoryEdit);

    function xxMemoryEdit() {
        return {
            require: ['xxMemoryEdit', '^^xxMemoryList'],
            restrict: 'AE',
            templateUrl: 'app/memories/memory-edit.html',
            controller: MemoryEditCtrl,
            scope: { pristine: '=memory' },
            bindToController: true,
            controllerAs: 'vm',
            link: link
        };

        function link(scope, iElement, iAttrs, ctrls) {
            var xxMemoryEdit = ctrls[0], xxMemoryList = ctrls[1];
            xxMemoryEdit.init(xxMemoryList);
        }
    }

    var rContentType = /^(?:(image)\/.*|(video)\/.*|(notfound)|(unsupported))$/;

    MemoryEditCtrl.$inject = ['$scope', '$q', '$timeout', 'Media', app.modules.common.services.functions];
    function MemoryEditCtrl($scope, $q, $timeout, Media, ggFunctions) {
        var vm = this,
            memoryListCtrl,
            fileReader;

        // Properties
        vm.progressLoaded = null;
        vm.progressTotal = null;
        Object.defineProperty(vm, 'form', { get: formAccessor });

        // Init
        vm.init = init;

        // Upload Events
        vm.fileLoad = fileLoad;
        vm.fileError = fileError;
        vm.fileProgress = fileProgress;
        vm.mediaLoadError = mediaLoadError;

        // Misc
        vm.getMediaType = getMediaType;
        vm.clearMedia = setMedia.bind(vm, null);
        vm.cancelFileUpload = cancelFileUpload;

        // Save
        vm.save = save;
        vm.cancel = cancel;

        /////////////////////////////////////////

        // Init
        function init(xxMemoryList) {
            var memory = vm.memory = angular.copy(vm.pristine);
            memoryListCtrl = xxMemoryList;
            $scope.$on('$destroy', destroy);
        }

        // Upload Events
        function fileLoad(e) {
            var buffer = e.result;
            fileProgress(e);
            if (buffer.type.startsWith('image/')) 
                transformImage(buffer, setMedia);
            else
                setMedia(e.result);
        }
        function fileError(e) {
            fileProgress(e);
            if (e.error.name !== 'AbortError')
                alert(e.error);
        }
        function fileProgress(e) {
            var isProgress = e.type == 'fileprogress',
                lengthComputable = isProgress && e.lengthComputable;
            fileReader = isProgress ? e.reader : null;
            vm.progressLoaded = lengthComputable ? e.loaded : null;
            vm.progressTotal = lengthComputable ? e.total : null;
        }
        function mediaLoadError(e) {
            var memory = vm.memory,
                src = memory.$mediaReadLink;

            memory.$mediaContentType = src.indexOf('blob:') === 0 ? 'unsupported' : 'notfound';
        }

        // Misc
        function getMediaType() {
            var match = rContentType.exec(vm.memory.$mediaContentType);
            return match && (match[1] || match[2] || match[3] || match[4]) || 'unknown';
        }
        function cancelFileUpload() {
            fileReader && fileReader.abort();
        }

        // Save
        function cancel() {
            memoryListCtrl.notifyCancelled(vm.pristine);
        }
        function save() {
            var form = vm.form,
                memory = vm.memory,
                state,
                progressKey;

            form.dummy.$setValidity('savestate', true);
            if (form.$valid) {
                $q.when()
                    .then(prepare)
                    .then(saveMemory)
                    .then(restoreState)
                    .then(saveMedia)
                    .then(setPristine)
                    .catch(handleError)
                    .finally(final);
            }

            function prepare() {
                ggFunctions.toggleProcessing(true);
                state = {
                    $editing: memory.$editing,
                    $mediaContentType: memory.$mediaContentType,
                    $mediaEditLink: memory.$mediaEditLink,
                    $mediaReadLink: memory.$mediaReadLink,
                    $mediaBuffer: memory.$mediaBuffer,
                    $mediaName: memory.$mediaName,
                    $mediaSize: memory.$mediaSize
                };
                if (angular.isUndefined(state.$mediaEditLink))
                    delete state.$mediaEditLink;
            }

            function saveMemory() {
                return memory.id ? memory.$update() : memory.$save();
            }

            function restoreState() {
                angular.extend(memory, state);
            }

            function saveMedia() {
                var mediaReadLinkModel = form.$mediaReadLink;

                if (mediaReadLinkModel.$dirty) {
                    if (memory.$mediaBuffer) {
                        memoryListCtrl.beginProgress(progressKey = angular.guid());
                        return Media.update({ url: memory.$mediaEditLink, buffer: memory.$mediaBuffer, progressKey: progressKey }).$promise
                    }
                    else if (memory.$mediaEditLink) {
                        return Media.delete({ url: memory.$mediaEditLink }).$promise;
                    }
                    else
                        return null;
                }
            }

            function setPristine(media) {
                if (media) {
                    delete memory.$mediaBuffer;
                    delete memory.$mediaName;
                    delete memory.$mediaSize;
                    angular.revokeObjectURL(memory.$mediaReadLink); // free blob
                    memory.$mediaReadLink = media.readLink;
                    memory.$mediaContentType = media.contentType;
                }

                form.$setPristine();
                angular.merge(vm.pristine, memory);
                memoryListCtrl.notifySaved(vm.pristine);
            }

            function handleError(response) {
                var config = response.config,
                    method = config && config.method.toUpperCase(),
                    data = config && config.data,
                    type = data instanceof ArrayBuffer ? 'media' : angular.isObject(data) ? 'memory' : null,
                    message;

                message = angular.isString(response) ? response
                    : response instanceof Error ? response.message
                    : type == 'memory' ? 'Unable to save memory.'
                    : type == 'media' && method == 'DELETE' ? 'The text was saved, but could not delete the media'
                    : type == 'media' && method == 'PUT' ? 'The text was saved, but not the media'
                    : 'An unknown error occurred';

                form.dummy.$setViewValue(message);
                form.dummy.$setValidity('savestate', false);
                return $q.reject(response);
            }

            function final() {
                memoryListCtrl.endProgress(progressKey);
                ggFunctions.toggleProcessing(false);
            }
        }

        // Helpers
        function setMedia(buffer) {
            var memory = vm.memory,
                mediaReadLinkModel = vm.form.$mediaReadLink;

            angular.revokeObjectURL(memory.$mediaReadLink);
            memory.$mediaBuffer = buffer;
            mediaReadLinkModel.$setViewValue(buffer ? angular.createObjectURL(buffer) : null);
            memory.$mediaContentType = buffer && buffer.type || null;
            memory.$mediaSize = buffer && (buffer.byteLength || buffer.size || 0) || null;
            memory.$mediaName = buffer && buffer.name || null;
        }
        function formAccessor() {
            return $scope.form;
        }
        function alert(message) {
            $timeout(function () { window.alert(message); }, 0, false);
        }
        function destroy() {
            angular.revokeObjectURL(vm.memory.$mediaReadLink); 
        }

        function transformImage(buffer, callback) {
            var options = { maxWidth: 1024, maxHeight: 1024, orientation: true };
            buffer = new Blob([buffer], { type: buffer.type });
            if (!loadImage(buffer, imageLoadCallback, options))
                callback(buffer);
            
            function imageLoadCallback(img, data) {
                if (img instanceof HTMLCanvasElement) 
                    img.toBlob(blobCallback);
                else
                    callback(buffer);
            }
            
            function blobCallback(blob) {
                $scope.$apply(callback.bind(null, blob));
            }
        }
    }
})();